import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Game } from '../../../Core'

import * as selectors from '../battles.selectors'
import * as actions from '../battles.actions'
import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'

import BattleResume from './BattleResume'

const mapDispatchToProps = (dispatch) => {
  return {
    removeScreen: bindActionCreators(Game.actions.removeScreen, dispatch),
    addScreen: bindActionCreators(Game.actions.addScreen, dispatch),
    getBattle: bindActionCreators(actions.getBattle, dispatch),
    removeQuestion: bindActionCreators(actions.setBattleQuestion, dispatch),
    removeInfo: bindActionCreators(actions.setBattleInfo, dispatch),
    setIndividualBattle: bindActionCreators(actions.setIndividualBattle, dispatch),
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  }
}
const mapStateToProps = (state) => {
  return {
    resume: selectors.getBattleResume(state),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(BattleResume))
